import { fuego } from '@nandorojo/swr-firestore';
import { BOARD_TYPE, BOARD_TYPE_VALUE } from '@typings/boardType';
import { masterSet } from '@masterSetting/masterSet/masterSetting';
import {
  LATEST_INTEGRATE,
  LATEST_INTEGRATE_VALUE,
} from '@typings/mainHome/latestIntegrate';

type Props = {
  limit?: number;
  selectedTypes?: LATEST_INTEGRATE_VALUE[]; // 🔧 하위 호환성 유지
  selectedPaths?: string[]; // 🆕 path 기반 선택
};

type boardItemType = {
  typeName: BOARD_TYPE_VALUE;
  path: string;
};

export async function getAllCurrentDocs({
  limit,
  selectedTypes,
  selectedPaths,
}: Props) {
  // 🆕 path 기반 필터링 우선, 없으면 type 기반 필터링
  let cols: boardItemType[];

  if (selectedPaths && selectedPaths.length > 0) {
    // path로 직접 필터링
    cols = masterSet.boardSet.filter((item: boardItemType) =>
      selectedPaths.includes(item.path),
    );
  } else if (selectedTypes && selectedTypes.length > 0) {
    // 기존 방식: type으로 필터링
    const normalizedSelectedTypes = selectedTypes.map((type) =>
      type.toLowerCase(),
    );
    cols = masterSet.boardSet.filter((item: boardItemType) =>
      normalizedSelectedTypes.includes(item.typeName.toLowerCase()),
    );
  } else {
    cols = [];
  }

  const newArr = await Promise.allSettled(
    cols.map(async (item: boardItemType, index) => {
      const getDocs = await fuego.db
        .collection(item.path)
        .limit(10)
        .orderBy('createdAt', 'desc')
        .get()
        .then((res) => {
          const result = res.docs.map((doc) => {
            return {
              id: doc.id,
              collectionPath: item.path,
              boardType: item.typeName,
              ...doc.data(),
            };
          });
          return result;
        });
      return getDocs;
    }),
  ).then((results) => {
    const list = results.map((res: any) => res.value).flat();

    list.sort((x, y) => y.createdAt * 1000 - x.createdAt * 1000); // 빨리생성된 순으로 나열
    const newList = list.slice(0, limit);
    return newList;
  });

  return newArr;
}
